// extracted by mini-css-extract-plugin
export default {"component-tasks-table":"ComponentTasksTable_component-tasks-table__gBNqy","comment-expansion-container":"ComponentTasksTable_comment-expansion-container__-dzrw"};